import React, { useRef } from "react";
import { useState, useEffect } from "react";
import {
  AiOutlinePlus,
  AiTwotoneCalendar,
  AiOutlinePlusCircle,
} from "react-icons/ai";
import { Link, useLocation, useNavigate } from "react-router-dom";
import { FaFileUpload } from "react-icons/fa";
import { addDays, format, parseISO, subDays } from "date-fns";
import Loader from "../../commonComponent/Loader";
import {
  changeDateFormat,
  showToastError,
  showToastSuccess,
  changeDateFormatYYYY,
  isEmpty,
  getFileName,
  getFileExtinsion,
  filterSoftDeletedClient,
  sortByName,
} from "../../Utils/Helper";
import DeleteModal from "../../commonComponent/DeleteModal";
import DateInput from "../../commonComponent/CutomDatePicker";
import Sidebar from "../sidebar/Sidebar";
import Navbar from "../header/Navbar";
import { AiFillEye } from "react-icons/ai";
import { RiEdit2Fill, RiDeleteBinFill } from "react-icons/ri";
import ApiConfig from "../../config/ApiConfig";
import { Accordion, Dropdown } from "react-bootstrap";
import ButtonWithIcon from "../../commonComponent/ButtonWithIcon";
import {
  createCarePlanGoalService,
  getGoalListService,
  getSingleGoal,
  updateCarePlanGoalService,
  getSingleCarePlanListService,
  createCarePlanFileService,
  updateCarePlanService,
  getFitnessPlanListService,
  getCarePlanFormListService,
  deleteGoal,
  deleteCarePlanFileService,
} from "../../services/CreateCarePlanService";
import Button from "../../commonComponent/Button";
import MedicationsModal from "./MedicationsModal";
import SupplementsModal from "./SupplementsModal";
import AddPrograms from "./AddProgramsModal";
import { getActiveProgram } from "../../services/ActivePrograms";
import AssignGroups from "./AssignGroupsModal";
import AssignClients from "./AssignClientsModal";
import { getMyAssignedPatientList, getMyPatientList, getPatientList } from "../../services/PatientService";
import { getMyGroupList } from "../../services/GroupService";
import {
  getUploadFileCategory,
  uploadCareFile,
} from "../../services/FileUploadService";
import { ReactComponent as SupplementSvg } from "../../svg/SupplementSvg.svg";
import { ReactComponent as MedicationSvg } from "../../svg/MedicationSvg.svg";
import { ReactComponent as MealPlanSvg } from "../../svg/MealPlanSvg.svg";
import { ReactComponent as FitnessPlanSvg } from "../../svg/FitnessPlanSvg.svg";
import { ReactComponent as AffirmationsSvg } from "../../svg/AffirmationsSvg.svg";
import { ReactComponent as FormWaiverSvg } from "../../svg/FormWaiverSvg.svg";
import { ReactComponent as PlusSvg } from "../../svg/PlusSvg.svg";
import { ReactComponent as OcticonGoal } from "../../svg/Octicon_goal.svg";
import { ReactComponent as CardMembership } from "../../svg/CardMembership.svg";
import { ReactComponent as GroupsSvg } from "../../svg/GroupsSvg.svg";
import RadioGroupWithSearch from "../../commonComponent/RadioGroupWithSearch";
import { getMealPlanListService } from "../../services/MealService";
import PopupModal from "./carePlanTemplates/PopupModal";
import Popup from "../../commonComponent/Popup";
import SelectDropdown from "../../commonComponent/SelectDropdown";
import UpdateCarePlanDetail from "./UpdateCarePlanDetail";
import ProgressInCircle from "../../commonComponent/ProgressInCircle";
import { BsThreeDotsVertical } from "react-icons/bs";
import AddGoalBox from "./carePlanViewTemplates/AddGoalBox";
import moment from "moment";
import { Tab, TabList, TabPanel, Tabs } from "react-tabs";
import AvatarPopover from "../../commonComponent/AvtarPopover";
import { useHover } from "../../customHook/useHover";
import { useAuth } from "../../Context/AuthContext";
import { useTabList } from "../../Context/TabListContext";

const CareplanEdit = () => {
  const closeRef = useRef()
  let navigate = useNavigate();
  const location = useLocation();
  const [errModal, setErrModal] = useState(false)
  let plan = location?.state?.careplan || [];
  const [isLoading, setLoader] = useState(true);
  const [getGoalList, setGetGoalList] = useState([]); // eslint-disable-next-line
  const [getTaskList, setGetTaskList] = useState([]);
  const [carePlan, setCarePlan] = useState([]);
  const [carePrograms, setCarePrograms] = useState([]); // eslint-disable-next-line
  const [careUsers, setCareUsers] = useState([]); 
  const [careGroups, setCareGroups] = useState([]);
  const [careFiles, setCareFiles] = useState([]);
  const [careClients, setCareClients] = useState([]);
  const [groupLists, setGroupLists] = useState([]);
  const [patientLists, setPatientLists] = useState([]);
  // const [medicationDetails, setMedicationsDetails] = useState([]);
  const [medicationsDetails, setMedicationsDetails] = useState([]);
  // const [supplimentDetails, setSupplimentDetails] = useState([]);
  const [supplimentsDetails, setSupplimentsDetails] = useState([]); // eslint-disable-next-line
  const [programsName, setProgramsName] = useState([]);
  const [mealPlanList, setMealPlanList] = useState([]); // eslint-disable-next-line
  const [affirmationsDetails, setAffirmationsDetails] = useState([]); // eslint-disable-next-line
  const [formIdDetails, setFormIdDetails] = useState([]);
  const [mealPlan, setMealPlan] = useState([]);
  const [fitnessPlan, setFitnessPlan] = useState([]);
  const [fitnessList, setFitnessList] = useState([]);
  const [goalApiChange, setGoalApiChange] = useState("");
  const [isSubmit, setSubmit] = useState(false);
  const [goalId, setGoalId] = useState("");
  const [noOfDays, setNoOfDays] = useState(0);
  const [goalName, setGoalName] = useState("");
  const [description, setDescription] = useState("");
  const [startDate, setStartDate] = useState("");
  const [category, setCategory] = useState("");
  const [frequency, setFrequency] = useState("Daily");
  const [repeats, setRepeats] = useState("");
  const [formValues, setFormValues] = useState([]); // eslint-disable-next-line
  const [dateRange, setDateRange] = useState([]);
  const [error, setError] = useState(false);
  const [programList, setProgramList] = useState([]); // eslint-disable-next-line
  const [clientsName, setClientsName] = useState([]); // eslint-disable-next-line
  const [groupsName, setGroupsName] = useState([]);
  const [fileApiChange, setFileApiChange] = useState("");
  const [existList, setExistList] = useState(""); // eslint-disable-next-line
  const [fileName, setFileName] = useState(""); // eslint-disable-next-line
  const [fileDescription, setFileDescription] = useState("");
  const [fileUpload, setFileUpload] = useState("");
  const [getFileList, setGetFileList] = useState([]); // eslint-disable-next-line
  const [fileId, setFileId] = useState("");
  const [showPopup, setShowPopup] = useState(false);
  const [popupType, setPopupType] = useState();
  const [formList, setFormList] = useState([]); // eslint-disable-next-line
  const [loading2, setLoading2] = useState(false);
  const [savedGoalList, setSavedGoalList] = useState([]);
  const [selectedTab, setSelectedTab] = useState(0);
  const [isSaveAsGoal, setIsSaveAsGoal] = useState(false); // eslint-disable-next-line
  const { hoveredUserId, handleMouseEnter, handleMouseLeave } = useHover();
  const {isAdmin} = useAuth()
  const carePlanId = plan._id;
  useEffect(() => {
    getMealPlan();
    getFitnessPlanList();
    getSingleCarePlan();  // eslint-disable-next-line
  }, []);  

  const { setCareplanTabList } = useTabList();
  const {isFromDefault} = location.state

  const getSingleCarePlan = async () => {
    // setLoader1(true)
    // console.log(sessionId);
    try {
      if (!carePlanId) {
        return;
      }
      const response = await getSingleCarePlanListService(carePlanId);
      if (response.status === 200) {
        setCarePlan(response.data[0]);
        // setCareTitleCreate(response.data[0]?.name);
        // setCareDescriptionCreate(response.data[0]?.description);
        // setCareDuration(response.data[0]?.duration);
        // setAssignDateCreate(getDate(response.data[0]?.assignDate) || '');
        setCarePrograms(response.data[0]?.programs?.map((dt) => dt._id));
        setCareGroups(response.data[0]?.groups?.map((dt) => dt._id));
        setCareUsers(response.data[0]?.activatedUsers);
        setCareFiles(response.data[0]?.attachments);
        setCareClients(response.data[0]?.clients);
        setSupplimentsDetails(response.data[0].suppliments);
        setMedicationsDetails(response.data[0].medications);
        let mealDefaultOption = [];
        if (response.data[0].mealPlan !== null) {
          mealDefaultOption = {
            id: response.data[0].mealPlan._id,
            name: response.data[0].mealPlan.mealPlanName,
          };
        } else if (response.data[0].mealPlan === null) {
          mealDefaultOption = null;
        }
        setMealPlan(mealDefaultOption);
        let fitnessDefaultOption = [];
        if (response.data[0].fitnessPlan !== null) {
          fitnessDefaultOption = {
            id: response.data[0].fitnessPlan._id,
            name: response.data[0].fitnessPlan.planName,
          };
        } else if (response.data[0].fitnessPlan === null) {
          fitnessDefaultOption = null;
        }
        setFitnessPlan(fitnessDefaultOption);
        const result = response.data[0].affirmations?.map((item) => {
          return {
            label: item,
            value: item,
          };
        });
        setAffirmationsDetails(result);
        setFormIdDetails(response.data[0].formId);
        setFormIdDetails({
          label: response.data[0].formId.formName,
          value: response.data[0].formId._id,
        });
      } else {
        console.log(response?.data || response.message);
      }
      //   setLoader1(false)
    } catch (error) {
      error?.data?.data &&
        console.log(error?.data?.data || error.data?.message);
      //   setLoader1(false)
    }
  };
  const getPatientsInfo = () => {
    let finaldata = [];
    patientLists?.forEach((item) => {
      if (careClients?.includes(item._id)) {
        return finaldata.push({
          _id: item._id,
          clientsName: item.first_name + " " + item.last_name,
          profilePicture: item.profilePicture,
          assessmentScore: item.assessmentScore,
        });
      }
    });
    setClientsName(finaldata);
  };

  // const getPatientLists = async () => {
  //   try {
  //     const response = await getMyPatientList();
  //     if (response.status === 200) {
  //       setPatientLists(filterSoftDeletedClient(response?.data?.data));
  //     }
  //   } catch (error) {
  //     console.log(error);
  //   }
  // };

  const getPatientLists = async () => {
    setLoader(true);
    try {
      let assignedPatientResponse;
      let allPatientResponse;

      // Assuming isAdmin is a boolean indicating whether the user is an admin
      if (!isAdmin) {
        assignedPatientResponse = await getMyAssignedPatientList();
      }
      allPatientResponse = await getPatientList();

      setLoader(false);

      if (allPatientResponse.status === 200) {
        const assignedPatientData = assignedPatientResponse?.data?.data || [];
        const allPatientData = allPatientResponse?.data?.data || [];
        const combinedData = [...allPatientData];

        if (assignedPatientData.length > 0) {
          combinedData.push(...assignedPatientData);
        }
        let sortedData = sortByName(filterSoftDeletedClient(combinedData));
        setPatientLists(filterSoftDeletedClient(sortedData));
      }
    } catch (error) {
      setLoader(false);
      console.error(error);
    }
  };
  const getGroupLists = async () => {
    try {
      const response = await getMyGroupList();
      if (response.status === 200) {
        setGroupLists(response?.data?.data);
      }
    } catch (error) {
      console.log(error);
    }
  };
  const renderError = (msg, value) => {
    return value ? (
      <h6
        className="text-danger error"
        style={{ marginBottom: 15, marginTop: -15 }}
      >
        {msg}
      </h6>
    ) : null;
  };

  const getPrograms = async () => {
    try {
      const response = await getActiveProgram();
      // setLoader(false);
      if (response.status === 200) {
        setProgramList(response?.data?.data);
      }
    } catch (error) {
      console.log(error);
    }
  };

  const instandDn = (dt) => {
    const a = document.createElement("a");
    document.body.appendChild(a);
    var url = URL.createObjectURL(dt);
    a.href = url;
    a.download = dt.name;
    a.target = "_blank";
    a.click();
    setTimeout(() => {
      window.URL.revokeObjectURL(url);
      document.body.removeChild(a);
    }, 0);
  };

  const renderFileForm = () => {
    return (
      <form onSubmit={handleSubmitFile}>
        <div className="row">
          {/* <div className="col-md-12">
                  <p className="whole_label resFont">File Name <span style={{ color: "red", fontWeight: "bold" }}>*</span></p>
                  <input
                      type="text"
                      className="description_inputf mb-4"
                      placeholder="Eg. Sample module"
                      maxLength={80}
                      value={fileName}
                      onChange={(e) => {
                          setFileName(e.target.value);
                          setError({ ...error, name: false });
                      }}
                  />
                  {renderError('Please enter file name', error.name)}
              </div> */}

          {/* <div className="col-md-12">
                  <p className="whole_label resFont">Description <span style={{ color: "red", fontWeight: "bold" }}>*</span></p>
                  <textarea
                      type="text"
                      className="pt-3 description_inputf mb-4"
                      placeholder="Please add description..."
                      style={{ height: "200px" }}
                      value={fileDescription}
                      maxLength={200}
                      onChange={(e) => {
                          setFileDescription(e.target.value);
                          setError({ ...error, desc: false });
                      }}
                  />
                  {renderError('Please enter description', error.desc)}
              </div> */}

          <div className="col-md-12">
            <p className="whole_label resFont">
              Attach File{" "}
              <span style={{ color: "red", fontWeight: "bold" }}>*</span>
            </p>
            <div className="position-relative">
              <img
                alt="attached file"
                src={
                  fileUpload !== "" || existList !== ""
                    ? "images/pdf.png"
                    : "images/fileUpload.png"
                }
                style={{
                  objectFit:
                    fileUpload !== "" || existList !== "" ? "contain" : "cover",
                }}
                className="active_dummyimg p-3"
              />
              <input
                type="file"
                accept="application/pdf"
                className="form-control uploader-input"
                // value={`${ApiConfig.awsBaseUrl}careplan/${carePlanId}/${existList}`}
                onChange={(e) => {
                  setFileUpload(e.target.files[0]);
                  // setAttachmentList(URL.createObjectURL(e.target.files[0]));
                  setError({ ...error, file: false });
                }}
                onClick={(e) => (e.target.value = null)}
              />
            </div>
            <p
              onClick={() =>
                fileUpload !== ""
                  ? instandDn(fileUpload)
                  : existList !== ""
                  ? window.open(
                      ApiConfig.ImageUrl +
                        "careplan/" +
                        carePlanId +
                        "/" +
                        existList,
                      "_blank"
                    )
                  : null
              }
              className="badge rounded-pill bg-dark py-2 px-3 mt-1 pointer"
            >
              {fileUpload?.name || existList}
            </p>
            <div className="uploader-mask d-flex justify-content-center align-items-center mb-1">
              {/* <BsFillPlusCircleFill className="upload-icon" /> */}
            </div>
            {renderError("Please select file", error.file)}
          </div>

          <div className="col-md-12 text-center">
            <Button
              isLoading={isSubmit}
              disabled={isSubmit}
              type="submit"
              text={fileApiChange === "edit" ? "Update File" : "Add New File"}
              style={isSubmit ? { cursor: "none" } : {}}
              className="description_createsess"
              id="btn-close"
              data-bs-dismiss="modal"
              aria-label="Close"
            />
          </div>
        </div>
      </form>
    );
  };

  useEffect(() => {
    getSingleFileById(); // eslint-disable-next-line
  }, [carePlanId]);
  const getSingleFileById = async () => {
    setLoader(true);
    // console.log(sessionId);
    try {
      // if (!carePlanId) {
      //     return;
      // }
      const response = await getSingleCarePlanListService(carePlanId);
      // console.log(response.data[0].attachments, "response")
      if (response.status === 200) {
        setGetFileList(response.data[0].attachments);
        // setExistList("");
      } else {
        // console.log(response?.data || response.message);
      }
      setLoader(false);
    } catch (error) {
      error?.data?.data &&
        console.log(error?.data?.data || error.data?.message);
      setLoader(false);
    }
  };
  const handleSubmitFile = async (e) => {
    e.preventDefault();
    try {
      const documentName = fileUpload ? getFileName(fileUpload) : null;
      const documentExtinsion = fileUpload
        ? getFileExtinsion(fileUpload)
        : null;

      fileUpload &&
        (await uploadCareFile(
          fileUpload,
          getUploadFileCategory.carePlan,
          documentName + "." + documentExtinsion,
          carePlanId
        ));

      var params = {
        attachments: [
          ...getFileList,
          // "fileId": getFileList?.length ? getFileList[getFileList?.length - 1].fileId + 1 : 1,
          {
            // "fileName": fileName,
            // "description": fileDescription,
            file: documentName ? documentName + "." + documentExtinsion : "",
          },
        ],
      };
      if (fileApiChange === "edit") {
        let fileList = [...getFileList];
        // let fileIndex = fileList?.findIndex((item) => item.fileId == fileId)

        fileList[fileId] = {
          fileId: fileId,
          // "fileName": fileName,
          // "description": fileDescription,
          file: documentName ? documentName + "." + documentExtinsion : "",
          // "file": documentName ? documentName : existList
          // "file": documentName ? documentName : existList?.split("/").pop()
        };

        params = {
          ...params,
          attachments: fileList,
        };
      }
      fileApi(params, carePlanId);
    } catch (error) {
      setSubmit(false);
      showToastError(
        error?.data?.data || error.data?.message || "Some error occurred"
      );
    }
  };

  const fileApi = async (payload) => {
    try {
      const response = await createCarePlanFileService(payload, carePlanId);
      // setShowLoader(false)
      setSubmit(false);
      if (response.status === 200) {
        // props.onSave();
        document.getElementById("btn-close").click();
        showToastSuccess(`Action completed successfully`);
        getSingleFileById();
        getSingleCarePlan();
      } else {
        showToastError(
          response?.data || response.message || "Some error occurred"
        );
      }
    } catch (error) {
      // setShowLoader(false)
      showToastError(
        error?.data?.data || error.data?.message || "Some error occurred"
      );
    }
  };

  const getProgramsList = () => {
    let finaldata = [];
    programList?.forEach((item) => {
      if (carePrograms?.includes(item._id)) {
        return finaldata.push({
          _id: item._id,
          name: item.programName,
          startDate: item.startDate,
          createdBy: item.createdBy,
          programImage: item.programImage,
          programType: item.programType,
          description: item.description,
          endDate: item.endDate,
          programMembers: item.programMembers,
        });
      }
    });
    setProgramsName(finaldata);
  };

  let handleChange = (i, e) => {
    let newFormValues = [...formValues];
    newFormValues[i][e.target.name] = e.target.value;
    setFormValues(newFormValues);
  };

  let removeFormFields = (i) => {
    let newFormValues = [...formValues];
    newFormValues.splice(i, 1);
    setFormValues(newFormValues);
  };

  const checkFreq = (freq) => {
    let newDate = handleDateChange();

    if (freq === "Daily") {
      return [
        "Sunday",
        "Monday",
        "Tuesday",
        "Wednesday",
        "Thursday",
        "Friday",
        "Saturday",
      ];
    } else if (freq === "Weekly") {
      return [repeats];
    } else if (freq === "Monthly") {
      return [newDate];
    }
  };

  let addFormFields = () => {
    let newDate = handleDateChange();
    // console.log(formValues.lastIndexOf(), ' :Task Id');
    if (frequency === "Daily") {
      setFormValues([
        ...formValues,
        {
          taskId: formValues.at(-1) ? formValues.at(-1).taskId + 1 : 0,
          title: "",
          description: "",
          frequency: frequency,
          repeatsOn: [
            "Sunday",
            "Monday",
            "Tuesday",
            "Wednesday",
            "Thursday",
            "Friday",
            "Saturday",
          ],
          priority: "high",
        },
      ]);
    } else if (frequency === "Weekly") {
      setFormValues([
        ...formValues,
        {
          taskId: formValues.at(-1) ? formValues.at(-1).taskId + 1 : 0,
          title: "",
          description: "",
          frequency: frequency,
          repeatsOn: [repeats],
          priority: "high",
        },
      ]);
    } else if (frequency === "Monthly") {
      setFormValues([
        ...formValues,
        {
          taskId: formValues.at(-1) ? formValues.at(-1).taskId + 1 : 0,
          title: "",
          description: "",
          frequency: frequency,
          repeatsOn: [newDate],
          priority: "high",
        },
      ]);
    } else {
      setFormValues([
        ...formValues,
        {
          taskId: formValues.at(-1) ? formValues.at(-1).taskId + 1 : 0,
          title: "",
          description: "",
          frequency: frequency,
          repeatsOn: [
            "Sunday",
            "Monday",
            "Tuesday",
            "Wednesday",
            "Thursday",
            "Friday",
            "Saturday",
          ],
          priority: "high",
        },
      ]);
    }
  };

  // Get meal Plan
  const getMealPlan = async () => {
    const response = await getMealPlanListService();
    // setLoader(false);
    const result = response.map((item) => {
      return {
        name: item.mealPlanName,
        id: item._id,
      };
    });
    setMealPlanList(result);
  };

  // Get fitness Plan
  const getFitnessPlanList = async () => {
    const response = await getFitnessPlanListService();
    const result = response.data.map((item) => {
      return {
        name: item.planName,
        id: item._id,
      };
    });
    // console.log(result);
    setFitnessList(result);
  };

  const getSingleGoalById = async (goalId) => {
    setLoader(true);

    try {
      if (!goalId) {
        return;
      }
      const response = await getSingleGoal(goalId, carePlanId);

      if (response.status === 200) {
        const startDates = getDate(response?.data[0]?.startDate);
        setGoalName(response?.data[0]?.goalName);
        setDescription(response?.data[0]?.notes);
        setStartDate(startDates);
        setNoOfDays(
          response?.data[0]?.duration ? response?.data[0]?.duration : 0
        );
        setCategory(response.data[0].category);
        setFrequency(response.data[0].tasks[0]?.frequency || "daily");
        // setRepeats(response.data[0].tasks[0]?.repeatsOn);
        setFormValues(response.data[0].tasks);
        // console.log(response?.data[0], " - Goals");
      } else {
        console.log(response?.data || response.message);
      }
      setLoader(false);
    } catch (error) {
      error?.data?.data &&
        console.log(error?.data?.data || error.data?.message);
      setLoader(false);
    }
  };

  const getGoalDetails = async () => {
    try {
      const response = await getGoalListService(carePlanId);
      setLoader(false);
      if (response.status === 200) {
        setGetGoalList(response?.data);
      }
    } catch (error) {
      setLoader(false);
      // setGetSessionList([]);
    }
  };

  const handleSaveGoals = async (e) => {
    let params = {
      goalName: goalName,
      notes: description,
      startDate: startDate == null ? null : changeDateFormatYYYY(startDate),
      duration: Number(noOfDays),
      category: category,
      tasks: formValues
        .filter((it) => it.title)
        .map((dt) => {
          return {
            ...dt,
            // dates: dateRange,
            frequency: frequency,
            repeatsOn: checkFreq(frequency),
          };
        }),
    };
    if (params) {
      setSavedGoalList([...savedGoalList, params]);
    }
  };

  const handleSubmitGoal = async (e) => {
    console.log(e);

    e.preventDefault();
    if (!checkValidation()) {
      return;
    }
    setSubmit(true);

    if (goalApiChange === "edit") {
      try {
        var params = {
          goalId: goalId,
          goalName: goalName,
          notes: description,
          startDate: startDate == null ? null : changeDateFormatYYYY(startDate),
          duration: Number(noOfDays),
          category: category,
          tasks: formValues
            .filter((it) => it.title)
            .map((dt) => {
              return {
                ...dt,
                // dates: dateRange,
                frequency: frequency,
                repeatsOn: checkFreq(frequency),
              };
            }),
        };

        const response = await updateCarePlanGoalService(params, carePlanId);
        // setShowLoader(false)
        setSubmit(false);
        if (response.status === 200) {
          // props.onSave();
          showToastSuccess(`Goal Plan is updated`);
          getGoalDetails();
          document.getElementById("btn-close").click();
          closeRef.current.click()
        } else {
          showToastError(
            response?.data || response.message || "Some error occurred"
          );
        }
        // console.log(params, "Edit Goals Params");
      } catch (error) {
        setSubmit(false);
        // setShowLoader(false)
        showToastError(
          error?.data?.data || error.data?.message || "Some error occurred"
        );
      }
    } else {
      try {
        params = {
          goalName: goalName,
          notes: description,
          startDate: startDate == null ? null : changeDateFormatYYYY(startDate),
          duration: Number(noOfDays),
          category: category,
          tasks: formValues
            .filter((it) => it.title)
            .map((dt) => {
              return {
                ...dt,
                // dates: dateRange,
                frequency: frequency,
                repeatsOn: checkFreq(frequency),
              };
            }),
        };
        const response = await createCarePlanGoalService(params, carePlanId);
        setSubmit(false);
        if (response.status === 200) {
          // props.onSave();
          showToastSuccess(`Goal Plan is created`);
          getGoalDetails();
          document.getElementById("btn-close").click();
          closeRef.current.click()
        } else {
          showToastError(
            response?.data || response.message || "Some error occurred"
          );
        }
        // console.log(params, "New Goals Params");
      } catch (error) {
        setSubmit(false);
        showToastError(
          error?.data?.data || error.data?.message || "Some error occurred"
        );
      }
    }
  };
  const handleDateChange = () => {
    if (frequency === "Monthly") {
      let date = new Date(startDate);
      date.setDate(date.getDate() + 1);

      let newDate = moment(date).format("DD");
      return newDate;
    }
  };
  const getGroupsInfo = () => {
    let finaldata = [];
    groupLists?.forEach((item) => {
      if (careGroups?.includes(item._id)) {
        return finaldata.push({
          _id: item._id,
          groupsName: item.groupName,
          description: item.description,
          ImageUrl: item.ImageUrl,
          createdBy: item.createdBy,
          groupImage: item.groupImage,
        });
      }
    });
    setGroupsName(finaldata);
  };
  // Delete Goal
  const deleteGoals = async (goalId) => {
    try {
      const response = await deleteGoal(goalId, carePlanId);
      if (response) {
        showToastSuccess(response?.data || "Goal deleted successfully.");
        getGoalDetails();
      } else {
        showToastError(
          response?.data || response.message || "Some error occurred"
        );
      }
    } catch (error) {
      showToastError(
        error?.data?.data || error.data?.message || "Some error occurred"
      );
    }
  };

  const getDate = (date) => {
    try {
      if (date && new Date(date) !== "Invalid Date") {
        return new Date(date);
      }
      // return new Date()
    } catch (error) {}
  };

  const checkValidation = () => {
    try {
      let errorsResult = error;
      let isValid = true;

      if (!goalName || isEmpty(goalName)) {
        isValid = false;
        errorsResult = { ...errorsResult, name: true };
      }
      if (!description || isEmpty(description)) {
        isValid = false;
        errorsResult = { ...errorsResult, descr: true };
      }
      if (!startDate || isEmpty(startDate)) {
        isValid = false;
        errorsResult = { ...errorsResult, sDate: true };
      }
      if (!noOfDays || isEmpty(noOfDays)) {
        isValid = false;
        errorsResult = { ...errorsResult, eDate: true };
      }
      if (!category || isEmpty(category)) {
        isValid = false;
        errorsResult = { ...errorsResult, cat: true };
      }
      if( new Date(addDays(new Date(carePlan.createdAt), carePlan.duration)) <= new Date(addDays(new Date(startDate), noOfDays)) ){
        isValid = false;
        errorsResult = { ...errorsResult, dDate: true };
      }
      setError(errorsResult);


      setErrModal(!isValid)

      return isValid;

      // if (isValid) {
      //   handleSubmitGoal()
      // }
    } catch (error) {}
  };

  // const renderLoader1 = () => {
  //   return (
  //     <Loader
  //       visible={false}
  //       emptyTextKey={"noGoalsFound"}
  //       style={{ top: 0, position: "relative" }}
  //     />
  //   );
  // };

  useEffect(() => {
    getProgramsList(); // eslint-disable-next-line
  }, [carePrograms, programList]);
  useEffect(() => {
    getPatientsInfo(); // eslint-disable-next-line
  }, [careClients, patientLists]);
  useEffect(() => {
    getGroupsInfo(); // eslint-disable-next-line
  }, [careGroups, groupLists]);
  useEffect(() => {
    // eslint-disable-next-line
    getSingleCarePlan(); // eslint-disable-next-line
    getPatientLists(); // eslint-disable-next-line
    getGroupLists(); // eslint-disable-next-line
    getGoalDetails(); // eslint-disable-next-line
    getPrograms(); // eslint-disable-next-line
    getForms(); // eslint-disable-next-line
  }, [carePlanId]);
  const getForms = async () => {
    try {
      const response = await getCarePlanFormListService();
      // setLoader(false);
      if (response.status === 200) {
        setFormList(response?.data || []);
      }
    } catch (error) {
      console.log(error);
    }
  };
  const getFormName = () => {
    const result = formList.map((item) => {
      return {
        label: item.formName,
        value: item._id,
      };
    });
    return result || [];
  };
  // Post data
  const postData = async (data) => {
    // console.log(data);
    // setLoader(true);
    setLoading2(true);
    var params = {};

    // const filteredItems = careClients.map(id => {
    //   const item = clientsName.find(item => item._id === id);
    //   return item ? item._id : null; // Change 'name' to the parameter you want to extract
    // });
    const affirmationResult = affirmationsDetails?.map((item) => item.label);
    params["name"] = data ? data.name : plan?.name;
    params["description"] = data ? data.description : plan?.description;
    params["duration"] = Number(plan?.duration);
    params["assignDate"] =
      plan?.assignDate == null ? null : changeDateFormatYYYY(plan?.assignDate);
    params["mealPlan"] = mealPlan ? mealPlan.id : "";
    params["fitnessPlan"] = fitnessPlan ? fitnessPlan.id : "";
    params["affirmations"] = affirmationResult;
    params["programs"] = data?.programs
      ? data.programs
      : carePrograms
      ? carePrograms
      : [];
    params["formId"] = formIdDetails ? formIdDetails.value : "";
    params["medications"] = medicationsDetails;
    params["suppliments"] = supplimentsDetails;
    params["groups"] = data?.group ? data.group : careGroups ? careGroups : [];
    params["clients"] = data?.member
      ? data.member
      : careClients
      ? careClients
      : [];

    try {
      // if(clientId?.length > 0){
      //   const res = await deleteCareplan(clientId[0])
      // }
      const response = await updateCarePlanService(carePlanId, params);
      if (response.status === 200) {
        showToastSuccess(`Care Plan is updated`);
        // props.onSave();
        setCareClients([]);
        setCareGroups([]);
        getSingleCarePlan();
        // setLoader(false);
        setLoading2(false);

        // setProgramId(response.data.data.insertedId)
      } else {
        showToastError(
          response?.data || response.message || "Some error occurred"
        );
      }
    } catch (error) {
      setLoader(false);
      setLoading2(false);
      showToastError(
        error?.data?.data || error.data?.message || "Some error occurred"
      );
    }
  };

  // delete meal plan
  const deletePlan = async (type) => {
    setLoader(true);
    var params = {};
    params["name"] = plan?.name;
    params["description"] = plan?.description;
    params["duration"] = Number(plan?.duration);
    params["assignDate"] =
      plan?.assignDate == null ? null : changeDateFormatYYYY(plan?.assignDate);
    params["mealPlan"] =
      type !== "deleteMealPlan" ? (mealPlan ? mealPlan.id : "") : "";
    params["fitnessPlan"] =
      type !== "deleteFitnessPlan" ? (fitnessPlan ? fitnessPlan.id : "") : "";
    params["affirmations"] = plan.affirmations;
    params["programs"] = plan.programs ? plan.programs : [];
    params["formId"] =
      type !== "deleteForm" ? (formIdDetails ? formIdDetails : null) : null;
    params["medications"] = medicationsDetails;
    params["suppliments"] = supplimentsDetails;
    params["groups"] = careGroups ? careGroups : [];
    params["clients"] = careClients ? careClients : [];

    try {
      const response = await updateCarePlanService(carePlanId, params);
      if (response.status === 200) {
        showToastSuccess(`Care Plan is updated`);
        // props.onSave();
        setCareClients([]);
        setCareGroups([]);
        setCarePrograms([]);
        getSingleCarePlan();
        // setProgramId(response.data.data.insertedId)
      } else {
        showToastError(
          response?.data || response.message || "Some error occurred"
        );
      }
    } catch (error) {
      setLoader(false);
      showToastError(
        error?.data?.data || error.data?.message || "Some error occurred"
      );
    }
  };
  // Delete file
  const deleteFile = async (deleteFileId) => {
    var params = {
      carePlanId: carePlanId,
      fileName: deleteFileId,
    };
    console.log(params, "params");
    try {
      const response = await deleteCarePlanFileService(params);
      // setShowLoader(false)
      setSubmit(false);
      if (response.status === 200) {
        // props.onSave();
        document.getElementById("btn-close").click();
        showToastSuccess(`Action completed successfully`);
        getSingleFileById();
        getSingleCarePlan();
      } else {
        showToastError(
          response?.data || response.message || "Some error occurred"
        );
      }
    } catch (error) {
      // setShowLoader(false)
      showToastError(
        error?.data?.data || error.data?.message || "Some error occurred"
      );
    }
  };



  const renderForm = () => {
    return (
      <Tabs selectedIndex={selectedTab}>
        <TabList>
          <Tab onClick={()=>setSelectedTab(0)}>Create New</Tab>
          {/* <Tab onClick={()=>setSelectedTab(1)}>Use Templates</Tab> */}
        </TabList>
        <TabPanel>
          <form onSubmit={handleSubmitGoal}>
            <div className="row">
              <div className="col-md-12">
                <p className="whole_label resFont">
                  Goal Title
                  <span style={{ color: "red", fontWeight: "bold" }}>*</span>
                </p>
                <input
                  type="text"
                  placeholder="E.g. Aggressive blood pressure control to target values 130/80"
                  className="description_inputf mb-4"
                  value={goalName}
                  maxLength={80}
                  onChange={(e) => {
                    setGoalName(e.target.value);
                    setError({ ...error, name: false });
                  }}
                />
                {renderError("Please enter name", error.name)}
              </div>

              <div className="col-md-12">
                <p className="whole_label resFont">
                  Description
                  <span style={{ color: "red", fontWeight: "bold" }}>*</span>
                </p>
                <textarea
                  type="text"
                  className="description_inputf pt-3 mb-4"
                  placeholder="Please add description to give better clarity to goal..."
                  style={{ height: "200px" }}
                  maxLength={200}
                  value={description}
                  onChange={(e) => {
                    setDescription(e.target.value);
                    setError({ ...error, descr: false });
                  }}
                />
                {renderError("Please enter description", error.descr)}
              </div>
              <div className="col-md-12 mb-4">
                <p className="whole_label resFont">
                  Assign <span className="small_letter2">date</span>{" "}
                  <span style={{ color: "red", fontWeight: "bold" }}>*</span>
                </p>
                <DateInput
                  value={startDate}
                  onChangeDate={(date) => {
                    setError({ ...error, sDate: false });
                    setStartDate(date);
                  }}
                  minDate={startDate !== '' ? new Date(startDate) : new Date()}
                  maxDate={carePlan.createdAt !== '' ? addDays(new Date(carePlan.createdAt),carePlan.duration) : new Date()}
                  inputClassName={
                    "description_inputf d-flex mb-0 align-items-center"
                  }
                  disabled={ new Date() < new Date(carePlan.createdAt) ? true : false}
                />
                {error.sDate ? (
                  <h6
                    className="text-danger error"
                    style={{ marginBottom: 15, marginTop: 7 }}
                  >
                    {"Please select start date"}
                  </h6>
                ) : null}
              </div>
              <div className="col-md-12">
                <p className="whole_label resFont">
                  Duration<span className="small_letter2"></span>
                  <span style={{ color: "red", fontWeight: "bold" }}>*</span>
                </p>
                <input
                  type="number"
                  className="description_inputf mb-4"
                  placeholder="Number of Days"
                  value={noOfDays}
                  min="0"
                  id="days"
                  onChange={(e) => {
                    setNoOfDays(e.target.value);
                    setError({ ...error, eDate: false });
                    setError({ ...error, dDate: false });
                  }}
                  onWheel={(e) => e.currentTarget.blur()}
                  onTouchMove={(e) => e.currentTarget.blur()}
                />
                {renderError("Please enter number of days", error.eDate)}
                {renderError(`Careplan will end before ${moment(addDays(new Date(carePlan.createdAt),carePlan.duration)).format('DD-MM-yyyy')} please add duration according to end date of careplan `, error.dDate)}
                {/* <DateInput
                        value={endDate}
                        onChangeDate={(date) => {
                            setError({ ...error, eDate: false })
                            setEndDate(date)
                        }}
                        // minDate={startDateCreate ? startDateCreate : new Date()}
                        inputClassName={"description_inputf d-flex mb-0 align-items-center"} /> */}
                {/* {error.eDate ?
                        <h6 className="blog_error_text4" style={{ marginBottom: 15, marginTop: 7 }}>
                            {'Please select end date'}
                        </h6> : null} */}
              </div>

              <div className="col-sm-12">
                <div className="row">
                  <div className="col-md-6">
                    <p className="whole_label resFont">Frequency</p>
                    <select
                      name="freq"
                      value={frequency}
                      onChange={(e) => setFrequency(e.target.value)}
                      className="description_inputf"
                    >
                      {/* <option value="once">Once</option> */}
                      <option value="Daily">Daily</option>
                      <option value="Weekly">Weekly</option>
                      <option value="Monthly">Monthly</option>
                      {/* <option value="yearly">Yearly</option> */}
                    </select>
                  </div>
                  <div className="col-md-6">
                    <p className="whole_label resFont">Repeats On</p>
                    <select
                      name="repeats"
                      disabled={frequency !== "Weekly"}
                      value={repeats}
                      onChange={(e) => setRepeats(e.target.value)}
                      className="description_inputf"
                    >
                      <option value="Monday">Monday</option>
                      <option value="Tuesday">Tuesday</option>
                      <option value="Wednesday">Wednesday</option>
                      <option value="Thursday">Thursday</option>
                      <option value="Friday">Friday</option>
                      <option value="Saturday">Saturday</option>
                      <option value="Sunday">Sunday</option>
                    </select>
                  </div>
                </div>
              </div>

              <div className="col-md-12">
                <p className="whole_label resFont  ">Tasks</p>
                <div className="row">
                  {formValues.length > 0 && (
                    <>
                      {/* <div className="col-md-2"><p className="whole_label resFont fw-light">Title</p></div> */}
                      <div className="col-md-5">
                        <p className="whole_label resFont fw-light">Task Description</p>
                      </div>
                      <div className="col-md-3">
                        <p className="whole_label resFont fw-light">Frequency</p>
                      </div>
                      {/* <div className="col-md-2"><p className="whole_label resFont fw-light">Repeats On</p></div> */}
                      <div className="col-md-3">
                        <p className="whole_label resFont fw-light">Priority</p>
                      </div>
                    </>
                  )}
                  {formValues.map((element, index) => (
                    <>
                      {/* <div className="col-md-11">
                                    <input
                                        name="title"
                                        type="text"
                                        maxLength={100}
                                        className="description_inputf  "
                                        placeholder="Description"
                                        value={element?.title || ""} onChange={e => handleChange(index, e)}
                                    />
                                </div> */}
                      <div className="col-md-5">
                        <input
                          name="title"
                          type="text"
                          className="description_inputf  "
                          placeholder="Task Description"
                          value={element?.title || ""}
                          onChange={(e) => handleChange(index, e)}
                        />
                      </div>
                      <div className="col-md-3">
                        <select
                          name="frequency"
                          value={frequency}
                          // onChange={(e) => handleChange(index, e)}
                          className="description_inputf"
                        >
                          <option value="Daily">Daily</option>
                          <option value="Weekly">Weekly</option>
                          <option value="Monthly">Monthly</option>
                          <option value="Yearly">Yearly</option>
                          <option value="Once">Once</option>
                        </select>
                      </div>
                      {/* <div className="col-md-3">
                                    <select
                                        name="repeatsOn"
                                        disabled={element.frequency !== 'weekly'}
                                        value={element.repeatsOn[0] || ""}
                                        onChange={e => handleChange(index, e)}
                                        className="description_inputf">
                                        <option value="" selected disabled>Select</option>
                                        <option value="monday">Monday</option>
                                        <option value="tuesday">Tuesday</option>
                                        <option value="wednesday">Wednesday</option>
                                        <option value="thursday">Thursday</option>
                                        <option value="friday">Friday</option>
                                        <option value="saturday">Saturday</option>
                                        <option value="sunday">Sunday</option>
                                    </select>
                                </div> */}
                      <div className="col-md-3">
                        <select
                          name="priority"
                          value={element.priority || ""}
                          onChange={(e) => handleChange(index, e)}
                          className="description_inputf"
                        >
                          <option value="high">High</option>
                          <option value="medium">Medium</option>
                          <option value="low">Low</option>
                        </select>
                      </div>
                      {/* {
                              index ? */}
                      <div className="col-md-1">
                        <div
                          style={{
                            height: "54px",
                            backgroundColor: "rgb(255, 255, 255)",
                            color: "black",
                            border: "1px solid rgb(187, 185, 185)",
                          }}
                          className="pointer border-0 mx-0 d-flex justify-content-center align-items-center text-danger px-0"
                          onClick={() => removeFormFields(index)}
                        >
                          <RiDeleteBinFill size="1.4em" />
                        </div>
                      </div>
                      {/* : null
                            } */}
                    </>
                  ))}

                  <div className="col-md-12">
                    <div
                      style={{ marginBottom: "35px", width: "max-content" }}
                      className="pointer description_btnsave mx-0 d-flex justify-content-center align-items-center"
                      onClick={() => addFormFields()}
                    >
                      <AiOutlinePlus className="me-2" /> Add New Tasks
                    </div>
                  </div>

                  <div className="col-md-12">
                    <p className="whole_label resFont">
                      Category{" "}
                      <span style={{ color: "red", fontWeight: "bold" }}>
                        *
                      </span>
                    </p>
                    <select
                      name=""
                      value={category}
                      onChange={(e) => {
                        setCategory(e.target.value);
                        setError({ ...error, cat: false });
                      }}
                      className="description_inputf mb-4"
                    >
                      <option disabled value="">{`Please choose...`}</option>
                      <option value="nutrition">Nutrition</option>
                      <option value="fitness">Fitness</option>
                      <option value="lifestyle">LifeStyle</option>
                      <option value="health">Health</option>
                      {/* {getDropDownSessionDays().map((item) => <option value={item}>{item}</option>)} */}
                    </select>
                    {renderError("Please select category", error.cat)}
                  </div>
                  {/* <div className="d-flex align-items-center">
                    <b style={{ fontSize: "18px" }}>Save Goal as Template:</b>{" "}
                    <Checkbox
                      color="success"
                      onChange={()=>setIsSaveAsGoal(!isSaveAsGoal)}
                      checked={isSaveAsGoal}
                    />
                  </div> */}

                  {/* <div className="col-md-12">
                  <p className="whole_label resFont  ">
                    Save Goal as Template : <input type="checkbox" />
                  </p>
                </div> */}
                </div>
              </div>

              <div className="col-md-12">
                <hr />
                <div className="d-flex justify-content-between">
                  <div
                    style={
                      isLoading
                        ? { pointerEvents: "none" }
                        : {
                            backgroundColor: "#fff",
                            color: "black",
                            border: "1px solid #bbb9b9",
                          }
                    }
                    className="description_btnsave pointer d-flex justify-content-center align-items-center"
                    data-bs-dismiss="modal"
                    aria-label="Close"
                  >
                    Cancel
                  </div>
                  {!isSaveAsGoal ? (
                    <Button
                      isLoading={isSubmit}
                      disabled={isSubmit}
                      type="submit"
                      id="reateProgram"

                      text={
                        goalApiChange === "edit"
                          ? "Update Goal Plan"
                          : "Create New Goal"
                      }
                      style={isSubmit ? { pointerEvents: "none" } : {}}
                      className="description_btnsave d-flex justify-content-center align-items-center"
                    />
                  ) : (
                    <Button
                      onClick={() => {
                        handleSaveGoals();
                        setSelectedTab(1);
                      }}
                      text={"Save"}
                      style={isSubmit ? { pointerEvents: "none" } : {}}
                      className="description_btnsave d-flex justify-content-center align-items-center"
                    />
                  )}
                </div>
              </div>
            </div>
          </form>
        </TabPanel>
        {/* <TabPanel>
          <UseTemplate
            GoalList={savedGoalList}
            setGoalList={setSavedGoalList}
            addGoal={handleSubmitGoal}
            editGoal={(id) => {
              setGoalApiChange("edit");
              setSelectedTab(0)
              setGoalId(id);
              getSingleGoalById(id);
            }}
          />
        </TabPanel> */}
      </Tabs>
    );
  };
  return (
    <>
      <Navbar />
      <div className="container-fluid">
        <div className="row">
          <div className="col-md-2">
            <Sidebar />
          </div>
          {isLoading ? (
            <center>
              <Loader
                visible={isLoading}
                style={{ top: "-15px", position: "relative" }}
              />
            </center>
          ) : (
            <div className="col-md-10 py-4 px-5">
              <nav
                aria-label="breadcrumb "
                className="d-flex justify-content-between mw-100"
              >
                <ol class="breadcrumb">
                <li class="breadcrumb-item cursor-pointer" onClick={() => navigate('/')}>Home</li>
                  <li
                    class="breadcrumb-item pointer"
                    onClick={() => navigate("/careplan")}
                  >
                    Care Plan
                  </li>
                  <li
                    class="breadcrumb-item active fw-bold"
                    aria-current="page"
                  >
                    {carePlan?.name}
                  </li>
                </ol>
                {/* <UpdateCarePlanDetail
                  carePlanName={carePlan?.name}
                  carePlanDescription={carePlan?.description}
                  carePlanAssignedBy={plan?.userId?.full_name}
                  postData={postData}
                /> */}
              </nav>
              <div className="row px-2 ">
                <div className="col-md-12">
                  <div className="my-4">
                    <div className="d-flex justify-content-start gap-2 align-items-center">
                      <h2 className="chidHeadFont">{carePlan?.name}</h2>
                      <UpdateCarePlanDetail
                        noLabel={true}
                        carePlanName={carePlan?.name}
                        carePlanDescription={carePlan?.description}
                        carePlanAssignedBy={plan?.userId?.full_name}
                        postData={postData}
                      />
                    </div>
                    <p className="resFont">{carePlan?.description}</p>
                  </div>
                </div>
                <div className="col-md-8">
                  <div className="d-flex">
                    <p className="me-3 mb-0">
                      Assigned by: <strong>{plan?.userId?.full_name}</strong>
                    </p>
                    <p className="mb-0">
                      Created on:{" "}
                      <strong>
                        {format(parseISO(plan?.createdAt), "MMM d, yyyy")}
                      </strong>
                    </p>
                  </div>
                  <hr />

                  <h5 className="text-green fw-bold headFont">Goals</h5>
                  {getGoalList.map((goal, index) => {
                    // console.log(goal, "goal");
                    return (
                      <div className="d-flex mb-3" key={goal._id}>
                        <span className="px-3 py-4 numbr">
                          {index + 1 < 10 && "0"}
                          {index + 1}
                        </span>
                        {/* <span className="px-3 py-4 numbr">01</span> */}
                        <div className="card px-4 py-3 flex-grow-1 ">
                          <div className="d-flex flex-row justify-content-between align-items-center w-100">
                            <div
                              onClick={() => setGetTaskList(goal.tasks)}
                              className="w-100"
                            >
                              <div className="d-flex justify-content-between mw-100">
                                <div className="mr-auto">
                                  <h6>{goal?.goalName}</h6>
                                  <p className="resFont">{goal.notes}</p>
                                </div>
                              </div>
                              <div className="d-flex  d-flex gap-2 justify-content-end align-items-start">
                                {/* <button
                                className="btn btn-light"
                                data-bs-toggle="modal"
                                data-bs-target="#goalModal"
                                onClick={() => {
                                  setGoalApiChange("edit");
                                  setGoalId(goal._id);
                                  getSingleGoalById(goal._id);
                                }}
                              >
                                <ButtonWithIcon
                                <RiEdit2Fill />
                                Edit
                                 />
                              </button> */}
                                <ButtonWithIcon
                                  className="btn btn-light"
                                  data-bs-toggle="modal"
                                  data-bs-target="#goalModal"
                                  onClick={() => {
                                    setGoalApiChange("edit");
                                    setGoalId(goal._id);
                                    getSingleGoalById(goal._id);
                                  }}
                                  icon={<RiEdit2Fill />}
                                  label="Edit"
                                />
                                <ButtonWithIcon
                                  className="btn btn-light"
                                  icon={<AiFillEye />}
                                  label="View"
                                  data-bs-toggle="modal"
                                  data-bs-target="#goalModal"
                                  onClick={() => {
                                    setGoalApiChange("edit");
                                    setGoalId(goal._id);
                                    getSingleGoalById(goal._id);
                                  }}
                                />
                                <ButtonWithIcon
                                  className="btn btn-light"
                                  data-bs-toggle="modal"
                                  data-bs-target="#deleteGoal"
                                  onClick={() => {
                                    setGoalId(goal._id);
                                  }}
                                  icon={
                                    <RiDeleteBinFill
                                      size={14}
                                      style={{ marginTop: "-2px" }}
                                    />
                                  }
                                  label="Delete"
                                />
                              </div>
                              {/* Assign date */}
                              <div className="row">
                                <div className="col-sm-3">
                                  <p className="mb-0 me-3">Assign date: </p>
                                </div>
                                <div className="col-sm-3">
                                  <p className="mb-0 me-3 text-green fw-bold">
                                    {changeDateFormat(goal.startDate)}
                                  </p>
                                </div>
                                {/* <div className="col-sm-3"><p className="mb-0 me-3">Description</p></div>
                                                          <div className="col-sm-3"><p className="mb-0 me-3">{goal.notes}</p></div> */}

                                <div className="col-sm-3">
                                  <p className="mb-0 me-3">Duration: </p>
                                </div>
                                <div className="col-sm-3">
                                  <p className="mb-0 me-3">
                                    {goal.duration} days
                                  </p>
                                </div>
                                <div className="col-sm-3">
                                  <p className="mb-0 me-3">Category: </p>
                                </div>
                                <div className="col-sm-3">
                                  <p className="mb-0 me-3 text-green fw-bold">
                                    {goal.category}
                                  </p>
                                </div>
                              </div>
                            </div>
                          </div>
                          <Accordion className="mt-3">
                            <Accordion.Item eventKey="0">
                              <Accordion.Header>
                                <h6 className="mb-0 text-center">View tasks</h6>
                              </Accordion.Header>
                              <Accordion.Body>
                                <div className="row mt-3">
                                  <div className="col-sm-6">
                                    <h6>Tasks</h6>
                                  </div>
                                  <div className="col-sm-3">
                                    <h6>Frequency</h6>
                                  </div>
                                  <div className="col-sm-3">
                                    <h6>Priority</h6>
                                  </div>

                                  <ul>
                                    {goal.tasks.map((dt) => (
                                      <div className="row">
                                        <div className="col-sm-6">
                                          <li className="col-sm-6">
                                            {" "}
                                            <p className="mb-0">{dt.title}</p>
                                          </li>
                                        </div>
                                        <div className="col-sm-3">
                                          <p className="mb-0 text-capitalize">
                                            {dt.frequency}
                                          </p>
                                        </div>
                                        <div className="col-sm-3">
                                          <p className="mb-0 text-capitalize">
                                            {dt.priority}
                                          </p>
                                        </div>
                                      </div>
                                    ))}
                                  </ul>
                                </div>
                              </Accordion.Body>
                            </Accordion.Item>
                          </Accordion>
                        </div>
                      </div>
                    );
                  })}
                  {!getGoalList?.length ? (
                    <AddGoalBox
                      svg={<OcticonGoal />}
                      style={{
                        width: "605px",
                        height: "300px",
                        display: "flex",
                        alignItems: "center",
                        justifyContent: "center",
                        backgroundColor: "#FBFBFB",
                      }}
                      header=" Add Goals to this care plan by clicking on “Add New” or click here."
                      content={
                        <Link
                          className=" mt-2 text-green fw-bold d-flex gap-2 align-items-center whole_lable"
                          type="button"
                          data-bs-toggle="modal"
                          data-bs-target="#goalModal"
                          onClick={() => {
                            // getSessionById();
                            // getSessionDays();
                            setGoalName("");
                            setDescription("");
                            setStartDate("");
                            setNoOfDays(0);
                            setCategory("");
                            setGoalApiChange("Add");
                            setFormValues([]);
                          }}
                          // to={props.addButtonPath}
                          // state={ props.stateValue}
                        >
                          <span>Click Here</span>
                        </Link>
                      }
                    />
                  ) : null}
                  <Link
                    className=" mt-2 text-green whole_label fw-bold d-flex gap-2 align-items-center"
                    type="button"
                    data-bs-toggle="modal"
                    data-bs-target="#goalModal"
                    onClick={() => {
                      // getSessionById();
                      // getSessionDays();
                      setGoalName("");
                      setDescription("");
                      setStartDate("");
                      setNoOfDays(0);
                      setCategory("");
                      setGoalApiChange("Add");
                      setFormValues([]);
                    }}
                    // to={props.addButtonPath}
                    // state={ props.stateValue}
                  >
                    <AiOutlinePlusCircle />
                    <span>Add New Goals</span>
                  </Link>
                  <hr />

                  {/* Programs */}
                  <h5 className="mb-4 text-green fw-bold">Programs</h5>
                  <div
                    className="d-flex gap-3 scroller-custom pb-2"
                    style={{ width: "100%", overflowX: "scroll" }}
                  >
                    {programsName.length > 0 && (
                      <>
                        {programsName.map((dt) => (
                          <div key={dt._id}>
                            <div
                              className="pointer d-flex flex-column justify-content-between rounded p-3 z-1 "
                              style={{
                                width: "350px",
                                height: "180px",
                                backgroundSize: "cover",
                                backgroundImage: `linear-gradient(180deg, rgba(4, 21, 21, 0) 0%, #041515 100%), url(${ApiConfig.ImageUrl}programs/${dt.createdBy}/${dt.programImage})`,
                              }}
                              onClick={() =>
                                navigate("/activeprograminfo", {
                                  state: { program: dt },
                                })
                              }
                            >
                              <div
                                className="d-flex justify-content-end"
                                onClick={(e) => {
                                  e.stopPropagation();
                                }}
                              >
                                {" "}
                                <Dropdown>
                                  <Dropdown.Toggle
                                    style={{
                                      backgroundColor: "transparent",
                                      border: "none",
                                      color: "white",
                                    }}
                                    className="custom"
                                    id="dropdown-basic"
                                  >
                                    <BsThreeDotsVertical />
                                  </Dropdown.Toggle>

                                  <Dropdown.Menu style={{ zIndex: "1000" }}>
                                    <Dropdown.Item
                                      onClick={() =>
                                        navigate("/activeprograminfo", {
                                          state: { program: dt },
                                        })
                                      }
                                    >
                                      View Details
                                    </Dropdown.Item>
                                    <Dropdown.Divider />
                                    <Dropdown.Item
                                      type="button"
                                      data-bs-toggle="modal"
                                      data-bs-target="#assignprogrammodal"
                                    >
                                      Update Program List
                                    </Dropdown.Item>
                                  </Dropdown.Menu>
                                </Dropdown>
                              </div>

                              <div>
                                <p className="mb-3 text-white fs-5">
                                  {dt.name}
                                </p>
                                <p className="mb-0 text-white">
                                  <AiTwotoneCalendar
                                    className="mb-1"
                                    size={"1.5em"}
                                  />{" "}
                                  {format(
                                    parseISO(dt.startDate),
                                    "do MMMM, yyyy"
                                  )}
                                </p>
                              </div>
                            </div>
                          </div>
                        ))}
                      </>
                    )}
                    {programsName.length < 0 || (
                      <div>
                        <div
                          className="pointer d-flex flex-column justify-content-end rounded p-3"
                          data-bs-toggle="modal"
                          data-bs-target="#assignprogrammodal"
                        >
                          <PlusSvg />
                          {/* <Link
                            className="whole_label resFont mt-2"
                            type="button"

                          >
                            Tap to add new
                          </Link> */}
                        </div>
                      </div>
                    )}
                  </div>

                  {/* Accordions */}
                  <div className="row">
                    {/* medication */}
                    <div className="col-md-6">
                      <Accordion
                        style={{ marginTop: "16px" }}
                        defaultActiveKey={"0"}
                      >
                        <Accordion.Item eventKey="0">
                          <Accordion.Header className="">
                            <MedicationSvg className="me-2 " />
                            <span
                              style={{ fontWeight: "600" }}
                              className="py-2"
                            >
                              Add Medications
                            </span>
                          </Accordion.Header>
                          <Accordion.Body>
                            {medicationsDetails
                              ? medicationsDetails.map((dt) => (
                                  <div
                                    key={dt.value}
                                    className="d-flex flex-row justify-content-between align-items-center"
                                  >
                                    <div className="w-50">
                                      <p className="mb-0">
                                        {dt.medicineName.label &&
                                          dt.medicineName.label}{" "}
                                      </p>
                                    </div>
                                    <div>{dt.quantity}</div>
                                    <div className="d-flex justify-content-center gap-3">
                                      <p
                                        className="whole_label resFont"
                                        type="button"
                                        data-bs-toggle="modal"
                                        data-bs-target="#medicationsModal"
                                      >
                                        <RiEdit2Fill className="me-1" />
                                      </p>
                                      <p
                                        className="whole_label resFont"
                                        type="button"
                                        data-bs-toggle="modal"
                                        data-bs-target="#medicationsModal"
                                      >
                                        <RiDeleteBinFill className="me-1" />
                                      </p>
                                    </div>
                                  </div>
                                ))
                              : null}
                            <div className="mt-2">
                              <p
                                className="whole_label resFont"
                                type="button"
                                data-bs-toggle="modal"
                                data-bs-target="#medicationsModal"
                              >
                                <AiOutlinePlusCircle className="me-1" />
                                Add Medications{" "}
                              </p>
                            </div>
                          </Accordion.Body>
                        </Accordion.Item>
                      </Accordion>
                    </div>
                    {/* Supplements */}
                    <div className="col-md-6">
                      <Accordion
                        style={{ marginTop: "16px" }}
                        defaultActiveKey={"0"}
                      >
                        <Accordion.Item eventKey="0">
                          <Accordion.Header>
                            {/* <RiCapsuleFill className="me-2" /> */}
                            <SupplementSvg className="me-2" />
                            <span style={{ fontWeight: "600" }}>
                              Add Supplements
                            </span>
                          </Accordion.Header>
                          <Accordion.Body>
                            {supplimentsDetails
                              ? supplimentsDetails.map((dt) => (
                                  <div
                                    key={dt.supplementName.value}
                                    className="d-flex flex-row justify-content-between align-items-center"
                                  >
                                    <div className="w-50">
                                      <p className="mb-0">
                                        {dt.supplementName.label}{" "}
                                      </p>
                                    </div>
                                    <div>{dt.quantity ? dt.quantity : ""}</div>
                                    <div className="d-flex justify-content-center gap-3">
                                      <p
                                        className="whole_label resFont"
                                        type="button"
                                        data-bs-toggle="modal"
                                        data-bs-target="#supplementsModal"
                                      >
                                        <RiEdit2Fill className="me-1" />
                                      </p>
                                      <p
                                        className="whole_label resFont"
                                        type="button"
                                        data-bs-toggle="modal"
                                        data-bs-target="#supplementsModal"
                                      >
                                        <RiDeleteBinFill className="me-1" />
                                      </p>
                                    </div>
                                  </div>
                                ))
                              : null}
                            <div className="mt-2">
                              <p
                                className="whole_label resFont"
                                type="button"
                                data-bs-toggle="modal"
                                data-bs-target="#supplementsModal"
                              >
                                <AiOutlinePlusCircle className="me-1" />
                                Add Supplements{" "}
                              </p>
                            </div>
                          </Accordion.Body>
                        </Accordion.Item>
                      </Accordion>
                    </div>
                  </div>
                  {/* Meal Plan */}
                  <div className="row">
                    <div className="col-md-6">
                      <Accordion
                        style={{ marginTop: "16px" }}
                        defaultActiveKey={"0"}
                      >
                        <Accordion.Item eventKey="0">
                          <Accordion.Header>
                            <MealPlanSvg className="me-2" />
                            <span style={{ fontWeight: "600" }}>
                              Add Meal Plan
                            </span>
                          </Accordion.Header>
                          <Accordion.Body>
                            {mealPlan !== null && mealPlan !== "" ? (
                              <div className="d-flex flex-row justify-content-between align-items-center">
                                <div className="w-50">
                                  <p className="mb-0 text-uppercase">
                                    {mealPlan?.name}{" "}
                                  </p>
                                </div>
                                <div className="d-flex justify-content-center gap-3">
                                  <p
                                    className="whole_label resFont"
                                    type="button"
                                    data-bs-toggle="modal"
                                    data-bs-target="#maleplanmodal"
                                  >
                                    <RiEdit2Fill className="me-1" />
                                  </p>
                                  <p
                                    className="whole_label resFont"
                                    type="button"
                                    data-bs-toggle="modal"
                                    data-bs-target="#DeleteMealPlan"
                                  >
                                    <RiDeleteBinFill className="me-1" />
                                  </p>
                                </div>
                              </div>
                            ) : null}
                            <p
                              className="whole_label resFont"
                              type="button"
                              data-bs-toggle="modal"
                              data-bs-target="#maleplanmodal"
                            >
                              <AiOutlinePlusCircle className="me-1" />
                              Add Meal Plan
                            </p>
                          </Accordion.Body>
                        </Accordion.Item>
                      </Accordion>
                    </div>
                    {/* Fitness Plan */}
                    <div className="col-md-6">
                      <Accordion
                        style={{ marginTop: "16px" }}
                        defaultActiveKey={"0"}
                      >
                        <Accordion.Item eventKey="0">
                          <Accordion.Header>
                            <FitnessPlanSvg className="me-2" />
                            <span style={{ fontWeight: "600" }}>
                              Add Fitness Plan
                            </span>
                          </Accordion.Header>
                          <Accordion.Body>
                            {fitnessPlan !== null && fitnessPlan !== "" ? (
                              <div className="d-flex flex-row justify-content-between align-items-center">
                                <div className="w-50">
                                  <p className="mb-0 text-uppercase">
                                    {fitnessPlan?.name}{" "}
                                  </p>
                                </div>
                                <div className="d-flex justify-content-center gap-3">
                                  <p
                                    className="whole_label resFont"
                                    type="button"
                                    data-bs-toggle="modal"
                                    data-bs-target="#fitnessplanmodal"
                                  >
                                    <RiEdit2Fill className="me-1" />
                                  </p>
                                  <p
                                    className="whole_label resFont"
                                    type="button"
                                    data-bs-toggle="modal"
                                    data-bs-target="#DeleteFitnessModal"
                                  >
                                    <RiDeleteBinFill className="me-1" />
                                  </p>
                                </div>
                              </div>
                            ) : null}
                            <p
                              className="whole_label resFont"
                              type="button"
                              data-bs-toggle="modal"
                              data-bs-target="#fitnessplanmodal"
                            >
                              <AiOutlinePlusCircle className="me-1" />
                              Add Fitness Plan
                            </p>
                            {/* {programsName ? programsName.map((dt) =>
                                <p className="text-muted mt-2"><GoDot /> {dt.programsName}</p>
                              ) : null} */}
                          </Accordion.Body>
                        </Accordion.Item>
                      </Accordion>
                    </div>
                  </div>
                  {/* <div className="row">
                <div className="col-md-6">
                  <Link
                    to={`/affirmationsview`}
                    state={{ plan }}
                    className="btn btn-primary btn-custom-light1 w-100"
                  >
                    <RiCapsuleFill className="me-2" />
                    Affirmations
                  </Link>
                </div>
                <div className="col-md-6">
                  <Link
                    to={`/formsview`}
                    state={{ plan }}
                    className="btn btn-primary btn-custom-light1 w-100"
                  >
                    <RiCapsuleFill className="me-2" />
                    Forms & Waivers
                  </Link>
                  <button className="btn btn-primary btn-custom-light1 w-100" onClick={() => navigate("/formsandwaiver", { state: { carePlan: carePlanId } })}>
                                          <RiCapsuleFill className="me-2" />
                                          Forms & Waivers
                                      </button>
                </div>
              </div> */}
                  {/*Affirmations  */}
                  <div className="row">
                    <div className="col-md-6">
                      <Accordion
                        style={{ marginTop: "16px" }}
                        defaultActiveKey={"0"}
                      >
                        <Accordion.Item eventKey="0">
                          <Accordion.Header>
                            <AffirmationsSvg className="me-2" />
                            <span style={{ fontWeight: "600" }}>
                              Add Affirmations Plan
                            </span>
                          </Accordion.Header>
                          <Accordion.Body>
                            {affirmationsDetails !== null &&
                            affirmationsDetails.length > 0  ? (
                              <div className="d-flex flex-row justify-content-between align-items-center">
                                <div className="w-50">
                                  <div className="mb-0 text-uppercase d-flex flex-row">
                                    {affirmationsDetails.map((dt, index) => (
                                      <div className="d-flex flex-row">
                                        <p key={dt}>{dt.label}</p>
                                        {index !==
                                          affirmationsDetails.length - 1 && (
                                          <span className="mr-2">
                                            {`, `}
                                            {` `}
                                          </span>
                                        )}
                                      </div>
                                    ))}
                                  </div>
                                </div>
                                <div className="d-flex justify-content-center gap-3">
                                  <p
                                    className="whole_label resFont"
                                    type="button"
                                    // data-bs-toggle="modal"
                                    // data-bs-target="#fitnessplanmodal"
                                    onClick={() => {
                                      setShowPopup(true);
                                      setPopupType("Affirmations");
                                    }}
                                  >
                                    <RiEdit2Fill className="me-1" />
                                  </p>
                                  <p
                                    className="whole_label resFont"
                                    type="button"
                                    onClick={() => {
                                      setShowPopup(true);
                                      setPopupType("Affirmations");
                                    }}
                                  >
                                    <RiDeleteBinFill className="me-1" />
                                  </p>
                                </div>
                              </div>
                            ) : null}
                            <p
                              className="whole_label resFont"
                              type="button"
                              onClick={() => {
                                setShowPopup(true);
                                setPopupType("Affirmations");
                              }}
                            >
                              <AiOutlinePlusCircle className="me-1" />
                              Add Affirmations Plan
                            </p>
                            {/* {programsName ? programsName.map((dt) =>
                                <p className="text-muted mt-2"><GoDot /> {dt.programsName}</p>
                              ) : null} */}
                          </Accordion.Body>
                        </Accordion.Item>
                      </Accordion>
                    </div>
                    {/* Forms & Waivers */}
                    <div className="col-md-6">
                      <Accordion
                        style={{ marginTop: "16px" }}
                        defaultActiveKey={"0"}
                      >
                        <Accordion.Item eventKey="0">
                          <Accordion.Header>
                            <FormWaiverSvg className="me-2" />
                            <span style={{ fontWeight: "600" }}>
                              Add Forms & Waivers
                            </span>
                          </Accordion.Header>
                          <Accordion.Body>
                            {formIdDetails !== null && formIdDetails !== "" ? (
                              <div className="d-flex flex-row justify-content-between align-items-center">
                                <div className="w-50">
                                  <p className="mb-0 text-uppercase d-flex flex-row">
                                    {formIdDetails.label}
                                  </p>
                                </div>
                                <div className="d-flex justify-content-center gap-3">
                                  <p
                                    className="whole_label resFont"
                                    type="button"
                                    // data-bs-toggle="modal"
                                    // data-bs-target="#fitnessplanmodal"
                                    onClick={() => {
                                      setShowPopup(true);
                                      setPopupType("forms");
                                    }}
                                  >
                                    <RiEdit2Fill className="me-1" />
                                  </p>
                                  <p
                                    className="whole_label resFont"
                                    type="button"
                                    data-bs-toggle="modal"
                                    data-bs-target="#DeleteFormModal"
                                  >
                                    <RiDeleteBinFill className="me-1" />
                                  </p>
                                </div>
                              </div>
                            ) : null}
                            <p
                              className="whole_label resFont"
                              type="button"
                              onClick={() => {
                                setShowPopup(true);
                                setPopupType("formDelete");
                              }}
                            >
                              <AiOutlinePlusCircle className="me-1" />
                              Add Affirmations Plan
                            </p>
                            {/* {programsName ? programsName.map((dt) =>
                                <p className="text-muted mt-2"><GoDot /> {dt.programsName}</p>
                              ) : null} */}
                          </Accordion.Body>
                        </Accordion.Item>
                      </Accordion>
                    </div>
                  </div>

                  {/* Modals */}
                  <MedicationsModal
                    medicationDetails={medicationsDetails}
                    setMedicationsDetails={setMedicationsDetails}
                    posDataFn
                    onClickEvent={postData}
                  />
                  <SupplementsModal
                    supplimentDetails={supplimentsDetails}
                    setSupplimentsDetails={setSupplimentsDetails}
                    posDataFn
                    onClickEvent={postData}
                  />
                  <AssignClients
                    members={careClients ? careClients : null}
                    setMembers={setCareClients}
                    patientsList={patientLists}
                    onClickEvent={postData}
                  />
                  <AssignGroups
                    members={careGroups ? careGroups : null}
                    setMembers={setCareGroups}
                    groupLists={groupLists}
                    onClickEvent={postData}
                  />
                  <AddPrograms
                    members={carePrograms ? carePrograms : null}
                    setMembers={setCarePrograms}
                    programsList={programList}
                    onClickEvent={postData}
                  />

                  <PopupModal
                    apiOptions={mealPlanList}
                    title="Add Meal Plan"
                    posDataFn
                    onClickEvent={postData}
                    preferredOption={mealPlan}
                    setPreferredOption={setMealPlan}
                    modalId="maleplanmodal"
                    radioButton
                    component={
                      <RadioGroupWithSearch
                        defaultOption={mealPlan}
                        setDefaultOption={setMealPlan}
                        apiOptions={mealPlanList}
                      />
                    }
                  />
                  <PopupModal
                    apiOptions={fitnessList}
                    title="Add Fitness Plan"
                    posDataFn
                    onClickEvent={postData}
                    preferredOption={fitnessPlan}
                    setPreferredOption={setFitnessPlan}
                    modalId="fitnessplanmodal"
                    radioButton
                    component={
                      <RadioGroupWithSearch
                        defaultOption={fitnessPlan}
                        setDefaultOption={setFitnessPlan}
                        apiOptions={fitnessList}
                      />
                    }
                  />
                  <Popup
                    show={showPopup}
                    onHide={() => setShowPopup(false)}
                    title="Affirmations"
                    content={
                      <>
                        {/* {popupType === "Affirmations" && <div>hi</div>} */}
                        {popupType === "Affirmations" && (
                          <div>
                            <SelectDropdown
                              isMulti
                              value={affirmationsDetails}
                              onChange={(data) => {
                                setAffirmationsDetails(data);
                              }}
                              placeholder={"Add Affirmations"}
                              options={[
                                { label: "Mindset", value: "Mindset" },
                                {
                                  label: "Relationships",
                                  value: "Relationships",
                                },
                                { label: "Motivation", value: "Motivation" },
                                {
                                  label: "Spirituality",
                                  value: "Spirituality",
                                },
                                { label: "Resilience", value: "Resilience" },
                              ]}
                            />
                            <div className="modal-footer px-3 border-0 mb-3">
                              <button
                                type="button"
                                onClick={() => {
                                  postData();
                                  setShowPopup(false);
                                }}
                                className="description_btnsave w-100 "
                                style={{
                                  backgroundColor: "#1F7E78",
                                  borderColor: "#1f7e78",
                                }}
                              >
                                {"Assign"}
                              </button>
                            </div>
                          </div>
                        )}
                        {popupType === "formDelete" && (
                          <div>
                            <SelectDropdown
                              value={formIdDetails}
                              onChange={(data) => {
                                setFormIdDetails(data);
                              }}
                              placeholder={"Add Forms & Waivers"}
                              options={getFormName()}
                            />
                            <div className="modal-footer px-3 border-0 mb-3">
                              <button
                                type="button"
                                onClick={() => {
                                  postData();
                                  setShowPopup(false);
                                }}
                                className="description_btnsave w-100 "
                                style={{
                                  backgroundColor: "#1F7E78",
                                  borderColor: "#1f7e78",
                                }}
                              >
                                {"Assign"}
                              </button>
                            </div>
                          </div>
                        )}
                        {popupType === "forms" && (
                          <div>
                            <SelectDropdown
                              value={formIdDetails}
                              onChange={(data) => {
                                setFormIdDetails(data);
                              }}
                              placeholder={"Add Forms & Waivers"}
                              options={getFormName()}
                            />
                            <div className="modal-footer px-3 border-0 mb-3">
                              <button
                                type="button"
                                onClick={() => {
                                  postData();
                                  setShowPopup(false);
                                }}
                                className="description_btnsave w-100 "
                                style={{
                                  backgroundColor: "#1F7E78",
                                  borderColor: "#1f7e78",
                                }}
                              >
                                {"Assign"}
                              </button>
                            </div>
                          </div>
                        )}
                      </>
                    }
                    position="top"
                    // btn1="Save"
                    // btn2="Cancel"
                  />

                  {/* <CareFitnessPlanEdits
                    members={carePrograms ? carePrograms : null}
                    setMembers={setCarePrograms}
                    programsList={programList}
                  /> */}

                  {/* <button onClick={()=>setShowPopup(true)}>Open Popup</button>
                  <Popup
                    show={showPopup}
                    onHide={()=>setShowPopup(false)}
                    title="Popup Title"
                    content={
                      <div >hi</div>}
                      position="top"
                      btn1="Save"
                      btn2="Cancel"
                  /> */}

                  <DeleteModal
                    title={"Delete"}
                    content1={"Are you sure you want to delete"}
                    content2={"this goal?"}
                    modalId={"deleteGoal"}
                    button2={"No"}
                    button1={"Yes"}
                    onDelete={() => deleteGoals(goalId)}
                  />
                  <DeleteModal
                    modalId="DeleteMealPlan"
                    content1="Are you sure you want to delete "
                    content2={"this meal plan?"}
                    button1="Delete"
                    button2="Cancel"
                    onDelete={(e) => {
                      e.preventDefault();
                      setMealPlan([]);
                      deletePlan("deleteMealPlan");
                    }}
                  />
                  <DeleteModal
                    modalId="DeleteFitnessModal"
                    content1="Are you sure you want to delete "
                    content2={"this fitness plan?"}
                    button1="Delete"
                    button2="Cancel"
                    onDelete={(e) => {
                      e.preventDefault();
                      setFitnessPlan([]);
                      deletePlan("deleteFitnessPlan");
                    }}
                  />
                  <DeleteModal
                    modalId="DeleteFormModal"
                    content1="Are you sure you want to delete "
                    content2={"this form and waiver?"}
                    button1="Delete"
                    button2="Cancel"
                    onDelete={(e) => {
                      e.preventDefault();
                      setFitnessPlan([]);
                      deletePlan("deleteForm");
                    }}
                  />
                </div>

                <div className="col-md-4">
                  <button
                    data-bs-placement="top"
                    className="btn btn-primary btn-custom w-100"
                    // onClick={() => { navigate("/editplan", { state: { careplan: plan } }) }}
                    // data-bs-toggle="modal" data-bs-target="#forumModal"
                  >
                    {/* <AiOutlinePlus className="me-2" /> */}
                    Assignments
                  </button>
                  <div className="top-users bg-gray mt-3 p-4 shadow-sm">
                    <div className="d-flex justify-content-between align-items-start ">
                      <div>
                        <h5 className="">
                          Members{" "}
                          <span className="text-muted font-weight-normal ">
                            ({clientsName?.length})
                          </span>
                        </h5>
                      </div>
                      <div className=" mr-5 pr-5 text-green">
                        <Link
                          className="whole_label resFont text-green "
                          type="button"
                          data-bs-toggle="modal"
                          data-bs-target="#assignclientsmodal"
                          // to={props.addButtonPath}
                          // state={ props.stateValue}
                        >
                          Add new
                        </Link>
                      </div>
                    </div>

                    <ul
                      className="scroller-custom list-group list-group-flush list-group-item-light w-100 position-relative "
                      style={{ height: "300px", overflowY: "scroll" }}
                    >
                      {clientsName.length > 0 &&
                        clientsName.map((dt) => {
                          console.log(dt);
                          return (
                            <div
                              className="d-flex pointer  justify-content-between align-items-start  list-group-item  w-100"
                              onClick={() => {
                                navigate("/allpatientinfo", {
                                  state: { user: dt },
                                });
                              }}
                              key={dt.userId}
                            >
                              <div className="mr-auto d-flex avatar_warper position-static "
                              onMouseEnter={() => handleMouseEnter(dt._id)}
                              onMouseLeave={handleMouseLeave}
                              >
                                <div className="forum_ava forum_ava_sm me-3">
                                  <img
                                    src={`${ApiConfig.ImageUrl}user/${dt._id}/${dt.profilePicture}`}
                                    onError={(e) => {
                                      e.target.src = "images/avatar.png"; //replacement image imported above
                                    }}
                                    alt=""
                                  />
                                  
                                </div>
                                <p className="mb-0 text-green">
                                  {dt.clientsName}
                                </p>
                                <AvatarPopover data={dt} onHover={dt._id === hoveredUserId}/>
                              </div>
                              
                              <div className="d-flex align-items-center gap-3 ">
                                <ProgressInCircle
                                  percentage={
                                    dt?.assessmentScore
                                      ? dt?.assessmentScore[0].points
                                      : 0
                                  }
                                  color="green"
                                  size="50px"
                                />
                                <Dropdown
                                  onClick={(e) => {
                                    e.stopPropagation();
                                  }}
                                >
                                  <Dropdown.Toggle
                                    style={{
                                      backgroundColor: "transparent",
                                      border: "none",
                                      color: "rgb(73, 80, 87)",
                                    }}
                                    className="custom"
                                    id="dropdown-basic"
                                  >
                                    <BsThreeDotsVertical />
                                  </Dropdown.Toggle>

                                  <Dropdown.Menu style={{ zIndex: "1000" }}>
                                    <Dropdown.Item
                                      onClick={() => {
                                        navigate("/allpatientinfo", {
                                          state: { user: dt },
                                        });
                                      }}
                                    >
                                      View Details
                                    </Dropdown.Item>
                                    <Dropdown.Divider />
                                    <Dropdown.Item
                                      type="button"
                                      data-bs-toggle="modal"
                                      data-bs-target="#assignclientsmodal"
                                    >
                                      Edit Member List
                                    </Dropdown.Item>
                                    <Dropdown.Divider />
                                    <Dropdown.Item
                                      onClick={() => {
                                        setClientsName(
                                          clientsName.filter(
                                            (item) => item._id !== dt._id
                                          )
                                        );
                                        let newArrClient = clientsName?.filter(
                                          (item) => {
                                            return item._id !== dt._id;
                                          }
                                        );

                                        console.log(
                                          newArrClient?.map((item) => {
                                            return item._id;
                                          })
                                        );
                                        setCareClients(
                                          newArrClient?.map((item) => {
                                            return item._id;
                                          })
                                        );
                                      }}
                                    >
                                      Remove Member
                                    </Dropdown.Item>
                                    {/* {isAdmin ?
                            <Dropdown.Item href="#/action-2" onClick={() => makeDefault(item._id)}>{item.default === true ? 'Remove as Default' : 'Make Default'}</Dropdown.Item>
                            : null}
                            <Dropdown.Item href="#/action-3" data-bs-toggle="modal" data-bs-target="#shareModal" onClick={() => getShareLink(item._id)}>Share Link</Dropdown.Item>
                            <Dropdown.Item href="#/action-4" data-bs-toggle="modal" data-bs-target="#deleteGroup" onClick={() => setGID(item._id)}>Delete</Dropdown.Item> */}
                                  </Dropdown.Menu>
                                </Dropdown>
                              </div>
                            </div>
                          );
                        })}
                      {!clientsName?.length ? (
                        <AddGoalBox
                          svg={<CardMembership />}
                          style={{
                            display: "flex",
                            alignItems: "center",
                            justifyContent: "center",
                            backgroundColor: "#FBFBFB",
                            marginTop: "20px",
                          }}
                          header=" Add Goals to this care plan by clicking on “Add New” or click here."
                          content={
                            <Link
                              className="whole_label resFont text-green "
                              type="button"
                              data-bs-toggle="modal"
                              data-bs-target="#assignclientsmodal"
                              // to={props.addButtonPath}
                              // state={ props.stateValue}
                            >
                              Click here
                            </Link>
                          }
                        />
                      ) : null}
                    </ul>

                    <hr className="mt-4" />
                    <div className="d-flex justify-content-between align-items-start ">
                      <div>
                        <h5 className="">
                          Groups{" "}
                          <span className="text-muted font-weight-normal ">
                            ({groupsName?.length})
                          </span>
                        </h5>
                      </div>
                      <div className=" mr-5 pr-5 text-green">
                        <Link
                          className="whole_label resFont text-green "
                          type="button"
                          data-bs-toggle="modal"
                          data-bs-target="#assigngroupsmodal"
                          // to={props.addButtonPath}
                          // state={ props.stateValue}
                        >
                          Add new
                        </Link>
                      </div>
                    </div>
                    {/* <h5>Groups</h5> */}
                    <div
                      className="member mt-4 scroller-custom pe-2"
                      style={{ height: "250px", overflowY: "scroll" }}
                    >
                      {groupsName.length > 0 &&
                        groupsName.map((dt) => (
                          <div
                            className="d-flex align-items-center  justify-content-between "
                            onClick={() =>
                              navigate("/groupactivities", {
                                state: {
                                  selectedGroup: dt,
                                  isFromCreate: false,
                                },
                              })
                            }
                            key={dt._id}
                          >
                            <div className="d-flex align-items-center mb-3 pointer">
                              <div
                                className="me-4 "
                                style={{
                                  width: "80px",
                                  height: "80px",
                                  aspectRatio: "2/2",
                                }}
                              >
                                <img
                                  src={`${ApiConfig.ImageUrl}groups/${dt.createdBy}/${dt.groupImage}`}
                                  onError={(e) => {
                                    e.target.src = "images/avatar.png"; //replacement image imported above
                                  }}
                                  alt=""
                                  className="w-100 h-100 rounded-circle"
                                />
                              </div>

                              <div className="d-flex flex-column">
                                <h5>{dt.groupsName}</h5>
                                <p className="mb-0 fs-small">
                                  {dt.description
                                    ? dt.description.substring(0, 66) + "..."
                                    : null}
                                </p>
                              </div>
                            </div>
                            <Dropdown
                              onClick={(e) => {
                                e.stopPropagation();
                              }}
                            >
                              <Dropdown.Toggle
                                style={{
                                  backgroundColor: "transparent",
                                  border: "none",
                                  color: "rgb(73, 80, 87)",
                                }}
                                className="custom"
                                id="dropdown-basic"
                              >
                                <BsThreeDotsVertical />
                              </Dropdown.Toggle>

                              <Dropdown.Menu style={{ zIndex: "1000" }}>
                                <Dropdown.Item
                                  onClick={() =>
                                    navigate("/groupactivities", {
                                      state: {
                                        selectedGroup: dt,
                                        isFromCreate: false,
                                      },
                                    })
                                  }
                                >
                                  View Group
                                </Dropdown.Item>
                                <Dropdown.Divider />
                                <Dropdown.Item
                                  type="button"
                                  data-bs-toggle="modal"
                                  data-bs-target="#assigngroupsmodal"
                                >
                                  Remove Group
                                </Dropdown.Item>
                                {/* {isAdmin ?
                            <Dropdown.Item href="#/action-2" onClick={() => makeDefault(item._id)}>{item.default === true ? 'Remove as Default' : 'Make Default'}</Dropdown.Item>
                            : null}
                            <Dropdown.Item href="#/action-3" data-bs-toggle="modal" data-bs-target="#shareModal" onClick={() => getShareLink(item._id)}>Share Link</Dropdown.Item>
                            <Dropdown.Item href="#/action-4" data-bs-toggle="modal" data-bs-target="#deleteGroup" onClick={() => setGID(item._id)}>Delete</Dropdown.Item> */}
                              </Dropdown.Menu>
                            </Dropdown>
                          </div>
                        ))}
                      {!groupsName?.length ? (
                        <AddGoalBox
                          svg={<GroupsSvg />}
                          header=" Add Goals to this care plan by clicking on “Add New” or click here."
                          content={
                            <Link
                              className="whole_label resFont text-green "
                              type="button"
                              data-bs-toggle="modal"
                              data-bs-target="#assigngroupsmodal"
                            >
                              Click here
                            </Link>
                          }
                        />
                      ) : null}
                    </div>
                  </div>
                  <div className="mt-3 p-4">
                    <h5>Files</h5>
                    {/* <button
                className="btn btn-primary btn-custom" data-bs-toggle="modal" data-bs-target="#sessionModal"
                style={{ marginLeft: "150px" }}
                onClick={() => {
                    // getSessionById();
                    setExistList("");
                    setFileName("");
                    setFileDescription("");
                    setFileUpload("");
                    setFileApiChange("Add");
                }}
                >file upload</button>                               */}
                    <button
                      className="btn btn-light mb-3"
                      data-bs-toggle="modal"
                      data-bs-target="#sessionModal"
                      style={{
                        width: "100%",
                        display: "flex",
                        alignItems: "center",
                        justifyContent: "space-between",
                      }}
                      onClick={() => {
                        // getSessionById();
                        setExistList("");
                        setFileName("");
                        setFileDescription("");
                        setFileUpload("");
                        setFileApiChange("Add");
                      }}
                    >
                      Upload File{<FaFileUpload />}
                    </button>
                    {/* {careFiles.length} */}
                    <DeleteModal
                      title={"Delete"}
                      content1={"Are you sure you want to remove"}
                      content2={"this File?"}
                      modalId={"deleteFile"}
                      button2={"No"}
                      button1={"Yes"}
                      onDelete={() => deleteFile(fileId)}
                    />
                    <div
                      className="member mt-4 scroller-custom pe-2"
                      style={{ height: "250px", overflowY: "scroll" }}
                    >
                      {careFiles.length > 0 &&
                        careFiles.map((dt, i) => (
                          <div className="d-flex  gap-2">
                            <p
                              className="pointer"
                              onClick={() =>
                                window.open(
                                  ApiConfig.ImageUrl +
                                    "careplan/" +
                                    carePlanId +
                                    "/" +
                                    dt.file
                                )
                              }
                              key={i}
                            >
                              {dt.file}
                            </p>
                            <p
                              className="whole_label resFont"
                              type="button"
                              data-bs-toggle="modal"
                              data-bs-target="#deleteFile"
                              onClick={() => {
                                setFileId(dt.file);
                              }}
                            >
                              <RiDeleteBinFill className="me-1" />
                            </p>
                          </div>
                        ))}
                    </div>
                    {/* <!-- Modal --> */}
                    <div
                      class="modal fade"
                      id="sessionModal"
                      aria-labelledby="exampleModalLabel"
                      aria-hidden="true"
                    >
                      <div class="modal-dialog">
                        <div class="modal-content py-4 px-3">
                          <div class="modal-header border-0">
                            {/* <h5 class="modal-title" id="exampleModalLabel">Modal title</h5> */}
                            <h5>
                              {fileApiChange === "edit"
                                ? "Edit File"
                                : "Add New File"}
                            </h5>
                            <button
                              type="button"
                              class="btn-close"
                              id="btn-close"
                              data-bs-dismiss="modal"
                              aria-label="Close"
                            ></button>
                          </div>
                          <div class="modal-body">
                            {isLoading ? (
                              <center>
                                <div
                                  style={{
                                    width: "3rem",
                                    height: "3rem",
                                    color: "#1f7e78",
                                  }}
                                  class="spinner-border mt-3 mb-4"
                                  role="status"
                                />
                              </center>
                            ) : (
                              renderFileForm()
                            )}
                          </div>
                          {/* </div> */}
                          {/* <div class="modal-footer">
            <button type="button" class="btn btn-secondary" data-bs-dismiss="modal">Close</button>
            <button type="button" class="btn btn-primary">Save changes</button>
          </div> */}
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              {/* Action Button */}
              <div className="col-md-12">
                <hr />
                <div className="d-flex justify-content-end gap-2">
                  <p
                    style={
                      isLoading
                        ? { cursor: "none" }
                        : {
                            cursor: "pointer",
                            backgroundColor: "#fff",
                            color: "black",
                            border: "1px solid #bbb9b9",
                            width: "120px",
                          }
                    }
                    onClick={() => !isLoading && navigate("/careplan")}
                    className="description_btnsave pointer d-flex justify-content-center align-items-center"
                  >
                    Cancel
                  </p>
                  <Button
                    postData
                    //   isLoading={isSubmit}
                    //   disabled={isSubmit}
                    //   onClick={() => {
                    //     setShowPopup(false);
                    //   }}
                    style={
                      isLoading
                        ? { cursor: "none" }
                        : {
                            cursor: "pointer",
                            width: "120px",
                          }
                    }
                    onClick={() => {
                      postData();
                      !isLoading && navigate("/careplan");
                      isFromDefault && setCareplanTabList('default')
                    }}
                    text="Save"
                    id="reateProgram"
                    className="description_btnsave d-flex justify-content-center align-items-center pointer"
                  >
                    Save
                  </Button>
                </div>
              </div>
              {/* <!-- Modal --> */}
              <div
                class="modal fade"
                id="forumModal"
                aria-labelledby="exampleModalLabel"
                aria-hidden="true"
              >
                <div class="modal-dialog">
                  <div class="modal-content py-4 px-3">
                    <div class="modal-header border-0">
                      {/* <h5 class="modal-title" id="exampleModalLabel">Modal title</h5> */}
                      <h3>Add New Question</h3>
                      <button
                        type="button"
                        class="btn-close"
                        data-bs-dismiss="modal"
                        aria-label="Close"
                      ></button>
                    </div>
                    <div class="modal-body"></div>
                    {/* <div class="modal-footer">
                              <button type="button" class="btn btn-secondary" data-bs-dismiss="modal">Close</button>
                              <button type="button" class="btn btn-primary">Save changes</button>
                              </div> */}
                  </div>
                </div>
              </div>
            </div>
          )}
        </div>
      </div>
      {/* <!-- Modal --> */}
      <div
        class="modal fade"
        id="goalModal"
        aria-labelledby="exampleModalLabel"
        aria-hidden="true"
      >
        <div class="modal-dialog" style={{ maxWidth: "900px" }}>
          <div class="modal-content py-4 px-3">
            <div class="modal-header border-0">
              {/* <h5 class="modal-title" id="exampleModalLabel">Modal title</h5> */}
              <h5>
                {goalApiChange === "edit" ? "Edit Goal" : "Add a new goal"}
              </h5>
              <button
                type="button"
                class="btn-close"
                id="btn-close"
                data-bs-dismiss="modal"
                aria-label="Close"
                ref={closeRef}
              ></button>
            </div>
            <div class="modal-body">
              {isLoading ? (
                <center>
                  <div
                    style={{ width: "3rem", height: "3rem", color: "#1f7e78" }}
                    class="spinner-border mt-3 mb-4"
                    role="status"
                  />
                </center>
              ) : (
                renderForm()
              )}
            </div>
            {/* </div> */}
            {/* <div class="modal-footer">
              <button type="button" class="btn btn-secondary" data-bs-dismiss="modal">Close</button>
              <button type="button" class="btn btn-primary">Save changes</button>
            </div> */}
          </div>
        </div>
      </div>
    </>
  );
};

export default CareplanEdit;
